export const defaultModalProps = {
  width: 800,
  maskClosable: false,
  closable: false,
};
